
export const auxiliaryLayersStructure: any = {
    bing: 'Спутник Bing',
    indorAvia: 'Аэрофотосъёмка «Индор-Авиа»',
    allRoadObjects: "Все объекты"
}

export const rosreestrLayersStructure = [
    {
        caption: "Единицы кадастрового деления",
        children: [
            {
                caption: "Кадастровые округа",
                name: "okrug"
            },
            {
                caption: "Кадастровые районы",
                name: "raion"
            },
            {
                caption: "Кадастровые кварталы",
                name: "kvartal"
            }
        ]
    },
    {
        caption: "Объекты капитального строительства",
        children: [
            {
                caption: "Здания",
                name: "building"
            },
            {
                caption: "Сооружения",
                name: "construction"
            },
            {
                caption: "Объекты незавершенного строительства",
                name: "unfinishedBuilding"
            }
        ]
    },
    {
        caption: "Земельные участки из ЕГРН",
        name: "landPlots"
    },
    {
        caption: "Зоны с особыми условиями использования территории",
        children: [
            {
                caption: "ЗОУИТ объектов культурного наследия",
                name: "cultureZOUIT"
            },
            {
                caption: "ЗОУИТ объектов энергетики, связи, транспорта",
                name: "serviceZOUIT"
            },
            {
                caption: "ЗОУИТ природных территорий",
                name: "natureZOUIT"
            },
            {
                caption: "ЗОУИТ охраняемых объектов и безопасности",
                name: "secureZOUIT"
            },
            {
                caption: "Иные ЗОУИТ",
                name: "otherZOUIT"
            },
            {
                caption: "Особо охраняемые природные территории",
                name: "specialZOUIT"
            }
        ]
    },
    {
        caption: "Природные территории",
        children: [
            {
                caption: "Лесничества",
                name: "forestry"
            },
            {
                caption: "Береговые линии (границы водных объектов)",
                children: [
                    {
                        caption: "Береговые линии (границы водных объектов) (полигональный)",
                        name: "coastlinesPolygonal"
                    },
                    {
                        caption: "Береговые линии (границы водных объектов)(линейный)",
                        name: "coastlinesLinear"
                    }
                ]
            }
        ]
    }
]

export function configureLayersTreeNodes(treeValues: any, parentKey: string = '') {
    let count = 0;
    return treeValues.map((treeValue: any) => {
        const key = parentKey ? `${parentKey}-${count}` : `${count}`;
        const children = treeValue?.children
        const data = treeValue?.name
        let treeNode: any = {
            key,
            label: treeValue.caption,
        };
        if (data) {
            treeNode = { ...treeNode, data }
        }
        if (children) {
            treeNode = { ...treeNode, children: configureLayersTreeNodes(children, key) }
        }
        count++;
        return treeNode
    })
}

export function defineAppliedLayersTreeValues(treeNodes: any, selectedTreeKeys: any, appliedLayersTreeValues: any = {}) {
    treeNodes.map((treeNode: any) => {
        if (treeNode.data) {
            let checked = Object.keys(selectedTreeKeys).includes(treeNode.key)
            Object.assign(appliedLayersTreeValues, { [treeNode.data]: checked })
        }
        if (treeNode.children) {
            defineAppliedLayersTreeValues(treeNode.children, selectedTreeKeys, appliedLayersTreeValues)
        }
    })
    return appliedLayersTreeValues
}